/** Firestore rejects `undefined` field values — omit those keys before writes. */
export function stripUndefinedFields<T>(value: T): T {
    if (value === undefined) {
        return value;
    }

    if (Array.isArray(value)) {
        return value.map((item) => stripUndefinedFields(item)) as T;
    }

    if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
        return Object.fromEntries(
            Object.entries(value as Record<string, unknown>)
                .filter(([, fieldValue]) => fieldValue !== undefined)
                .map(([key, fieldValue]) => [key, stripUndefinedFields(fieldValue)]),
        ) as T;
    }

    return value;
}

export function recipeUpdatePayload(recipe: Record<string, unknown>): Record<string, unknown> {
    const { id: _id, ...payload } = recipe;
    return stripUndefinedFields({
        ...payload,
        updatedAt: new Date().toISOString(),
    });
}
